import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { ScoreTypesComponent } from "../../components/scoreTypes"

export const ScoreTypesPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <ScoreTypesComponent />
    </DefaultPageComp>
  </>
}